import { ComponentType, Suspense, useEffect } from "react";

import { useLayoutLoaderHandler } from "@valenzinsights/react-core";

export const withSuspense =
	<P extends object>(Component: ComponentType<P>): ComponentType<P> =>
	(props: P) => {
		const { showLoader, hideLoader } = useLayoutLoaderHandler();

		const Fallback = () => {
			useEffect(() => {
				showLoader();
				return () => hideLoader();
			}, []);

			return null;
		};

		return (
			<Suspense fallback={<Fallback />}>
				<Component {...props} />
			</Suspense>
		);
	};
